import { Menu, MenuButton, MenuItem, MenuList } from '@chakra-ui/menu';
import { Portal } from '@chakra-ui/portal';
import { MoreIcon } from '@sketchnote/icons';
import cn from 'classnames';
import * as React from 'react';

import { MoreActionMenuProps } from './types';

const { useCallback } = React;

export const MoreActionMenu = ({
  icon = <MoreIcon />,
  menuItems,
  onClickMenuItem,
  onOpenMenu,
  onCloseMenu,
  classNames,
  placement,
}: MoreActionMenuProps): JSX.Element => {
  const handlePropagation: React.MouseEventHandler<HTMLButtonElement> = useCallback((e) => {
    e.stopPropagation();
  }, []);
  return (
    <Menu
      onClose={onCloseMenu}
      onOpen={onOpenMenu}
      placement={placement}
      isLazy
      modifiers={[{ name: 'eventListeners', options: { scroll: true } }]}
    >
      <MenuButton
        onClick={handlePropagation}
        className={cn({
          'inline-block focus:shadow-outline': true,
          [classNames?.labelWrap || '']: !!classNames?.labelWrap,
        })}
      >
        {icon}
      </MenuButton>

      <Portal>
        <div className="more-menu-popover">
          <MenuList
            style={{ zIndex: 1000 }}
            className={cn({
              'bg-white min-w-160 p-6 flex-col inline-flex shadow-sm rounded-md w-full': true,
              [classNames?.menuWrap || '']: !!classNames?.menuWrap,
            })}
          >
            {menuItems.map((menu) => (
              <MenuItem
                key={menu.value}
                onClick={onClickMenuItem?.bind(this, menu) as any}
                className="active:text-primary-500 font-medium text-xs flex px-8 py-7 w-full rounded-sm min-w-btn-lg focus:bg-gray-100 hover:bg-gray-100 cursor-pointer align-middle"
              >
                {menu.icon ? (
                  <span className="text-gray-500 mr-8 align-middle">{menu.icon}</span>
                ) : null}
                <span className="align-middle">{menu.label}</span>
              </MenuItem>
            ))}
          </MenuList>
        </div>
      </Portal>
    </Menu>
  );
};
